import { useProject } from '@hooks/useProject'
import { FC } from 'react'
import { DialogBase, Dialog, Button } from 'ui'
import { useTranslations } from 'use-intl'

export const IncompatibleChromeVersionDialog: FC = () => {
  const t = useTranslations()

  const {
    showIncompatibleChromeVersionDialog,
    setShowIncompatibleChromeVersionDialog
  } = useProject()

  return (
    <DialogBase underlay open={showIncompatibleChromeVersionDialog}>
      <Dialog size="m" noDivider style={{ maxInlineSize: 450 }}>
        <h2 slot="heading">{t('compatibility:chromeVersion:header')}</h2>
        <p>{t('compatibility:chromeVersion:body:one')}</p>
        <p>{t('compatibility:chromeVersion:body:two')}</p>

        <Button
          onClick={() => setShowIncompatibleChromeVersionDialog(false)}
          treatment="outline"
          slot="button"
          variant="secondary"
        >
          {t('compatibility:chromeVersion:button')}
        </Button>
      </Dialog>
    </DialogBase>
  )
}
